<template>
    <div class="xr-input-file">
      <div class="xr-input-file__tags">
        <span class="xr-input-file__content">
          <span class="el-tag el-tag--info el-tag--mini el-tag--light" v-for="(item, index) in list">
            <span class="el-select__tags-text">{{item.label}}</span>
            <i class="el-tag__close el-icon-close" @click="deleteFile(index, item.value)"></i>
          </span>
        </span>
      </div>
      <span class="xr-input-file__suffix" @click="handleFileUploadDialogOpen">
        <i class="wk wk-upload1"></i>
      </span>
      <xr-upload ref="xrUploadDialog" :accept="accept" :targetId="targetId" :onUploadedClose="true" @confirmMethod="uploadSuccess(arguments)"></xr-upload>
    </div>
</template>
<script>
export default {
  name: 'XrInputFile',
  props: ['list', 'businessType', 'businessId', 'disabled','accept'],
  model: {
    prop: 'value',
    event: 'change'
  },
  computed: {
    targetId(){
      return this.businessType + '$' + this.businessId
    }
  },
  data() {
    return {
      selectedValue: ''
    }
  },
  watch: {
    value(newValue) {
      this.selectedValue = newValue;
    },
    list: {
      handler() {
        this.selectedValue = this.value;
      },
      deep: true
    },
    selectedValue(newValue){
      this.$emit('change', newValue);
    }
  },
  created() {
    this.$nextTick(()=>{
      this.selectedValue = this.value;
    })
  },
  methods: {
    selectedChange(){
    },
    //打开文件上传弹出页面
    handleFileUploadDialogOpen(){
      this.$refs.xrUploadDialog.init() //初始化页面
    },
    //导入成功后的操作
    uploadSuccess(msg){
      //关闭弹出窗
      // this.$refs.xrTable.getData();
      console.log(msg);
      let imgInfo = msg[1][0];
      let obj = new Object();
      obj.value = imgInfo['id'];
      obj.label = imgInfo['name'];
      this.list.push(obj);
    },
    //删除图片
    deleteFile(index,id){
      return this.request({
        method:'post',
        url:'/web/service',
        params:{
          'method': 'tCoreResource_delete',
          'id': id
        }
      }).then((response) =>{
        //如果不为0，提示错误提示语
        if(response.code !== 0){
          this.$message.error(response.msg);
          return false;
        }
        //成功后的处理
        this.list.splice(index, 1)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .xr-input-file{
    border: 1px solid #DCDFE6;
    height: 30px;
    border-radius: 4px;
    position: relative;
    .xr-input-file__suffix{
      position: absolute;
      right: 5px;
      top: 0px;
      -webkit-transition: all .3s;
      transition: all .3s;
      cursor: pointer;
    }
    .xr-input-file__suffix:hover{
      color: #1296db;
    }
    .xr-input-file__tags{
      width: 100%;
      .xr-input-file__content{
        display: contents;
      }
      .el-tag.el-tag--info{
        margin-right: 5px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/XrInputFile/index.vue